import { LG } from "../../styles/liquidGlass";

export const STYLES = {
    fontFamily: "inherit",
    colors: {
        primary: LG.color.text,
        accent: LG.color.text,
        discount: LG.color.textSecondary,
        secondary: LG.color.textSecondary,
        warning: "#dc8f38",
    },
    spacing: {
        drawerPadding: { xs: 2, sm: 4 },
        itemGap: 2,
        sectionMargin: 3,
    },
} as const;
